import styled from 'styled-components';

import Placeholder from '@assets/images/promotions/promo_placeholder.webp';

export const Wrapper = styled.div<{ $bg: string | null }>`
	height: 160px;
	border-radius: 12px;
	padding: 37px 16px;

	display: flex;
	flex-direction: column;
	justify-content: space-between;

	position: relative;

	background-image: url('${({ $bg }) => ($bg ? $bg : Placeholder)}');

	background-repeat: no-repeat;
	background-position: right;
	background-size: cover;
`;

export const PrizePlace = styled.p`
	font-size: 16px;
	line-height: 22px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.subtitle};

	text-transform: lowercase;
`;

export const PrizeType = styled.p`
	font-size: 18px;
	line-height: 25px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.subtitle};
`;

export const PrizeName = styled.h3`
	font-size: 20px;
	line-height: 27px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
`;
